/**
 * 呼び出し元画面の入力情報を格納するVO
 *
 * @export KYMW1204InputModel
 * @class KYMW1204InputModel
 */
export class KYMW1204InputModel {
  /** 価格パターン */
  public pricePattern: string = '';
  /** メモ内容 */
  public catalogMemo: string = '';
  /** コピーフラグ */
  public copyCatalogMemoFlg: boolean = false;
  /** サイクル確定フラグ */
  public cycleFixedFlg: boolean = false;
}
